var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 7.31673C0.0507812 11.3282 3.30272 14.5807 7.3142 14.5807C11.3257 14.5807 14.5776 11.3282 14.5776 7.31673C14.5776 3.30526 11.3257 0.0527344 7.3142 0.0527344C3.30272 0.0527344 0.0507812 3.30526 0.0507812 7.31673Z",
    fill: "#FFCB05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.144 7.36666C14.144 8.91749 11.0957 10.1746 7.33609 10.1746C3.57563 10.1746 0.527344 8.91749 0.527344 7.36666C0.527344 5.81584 3.57563 4.55957 7.33609 4.55957C11.0957 4.55957 14.144 5.81584 14.144 7.36666Z",
    fill: "#00678F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 8.75321L3.67288 5.94531H4.79788V7.58064L5.53742 5.94531H6.69863L5.99531 8.75321H5.25577L5.67744 6.94083L4.79788 8.75321H4.20078V6.94083L3.74209 8.75321H2.96875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92578 8.78859L7.0312 8.39746H7.84075L7.73453 8.78859H6.92578Z",
    fill: "#ED1D24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73828 8.75321L9.44161 5.94531H10.2512L10.6036 7.439L10.9899 5.94531H11.7286L11.0253 8.75321H10.2512L9.86409 7.22492L9.47702 8.75321H8.73828Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92623 5.94531L6.75 6.65674H7.48954L7.0912 8.19952H7.89995L8.29909 6.65674H9.03782L9.21325 5.94531H6.92623Z",
    fill: "#FFCB05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.08b2a54892d0743ba443eb419a76df42.svg";
export { ForwardRef as ReactComponent };